module.exports = __webpack_public_path__ + "img/626D5C_B8C2BB_1B230F_A4ACA3-256px.1f6c35b9.png";